import { render, staticRenderFns } from "./ViewCallHistory.vue?vue&type=template&id=7d7a6086"
import script from "./ViewCallHistory.vue?vue&type=script&lang=js"
export * from "./ViewCallHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports